import { render, staticRenderFns } from "./vehicle-details.vue?vue&type=template&id=422e5270&scoped=true&"
import script from "./vehicle-details.vue?vue&type=script&lang=js&"
export * from "./vehicle-details.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-details.vue?vue&type=style&index=0&id=422e5270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e5270",
  null
  
)

export default component.exports